import React from 'react';
import { AlertTriangleIcon, XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full py-20 px-4 bg-brand-alt border-y border-brand-card" data-id="element-99">
      <div className="max-w-4xl mx-auto space-y-16" data-id="element-100">
        {/* The Hook */}
        <div className="relative pl-6 md:pl-8 border-l-4 border-brand-gold bg-brand-card/50 p-6 md:p-8 rounded-r-xl shadow-lg" data-id="element-101">
          <p className="text-lg md:text-xl text-brand-text italic leading-relaxed" data-id="element-102">
            “Es sábado por la noche. Tu ‘apuesta segura’ se cae en el minuto 88.
            El tipster borra el mensaje. Sube una foto con dinero. Y escribe: ‘A
            por la siguiente, familia.’ Tú te quedas con la cuenta en cero… y la
            sensación de que te vieron la cara otra vez.” !! NO LOGRASTE PASAR
            DE 1,000 A 50,000 EN UNA JUGADA como te prometió.!!
          </p>
        </div>

        {/* The Problem */}
        <div className="space-y-6" data-id="element-103">
          <div className="flex items-center gap-3 mb-6" data-id="element-104">
            <AlertTriangleIcon className="w-8 h-8 text-brand-red" data-id="element-105" />
            <h2 className="text-3xl md:text-4xl text-brand-text" data-id="element-106">
              EL JUEGO ESTÁ DISEÑADO PARA QUE PIERDAS
            </h2>
          </div>
          <p className="text-lg text-brand-muted leading-relaxed" data-id="element-107">
            La mayoría de los apostadores viven atrapados en el mismo ciclo:
            Siguen picks de otros Apuestan por emoción Intentan recuperar
            pérdidas… y pierden más
          </p>
          <p className="text-lg text-brand-muted leading-relaxed font-medium text-brand-text" data-id="element-108">
            El negocio de los Tipsters no es que tú ganes; es que tú sigas
            pagando la suscripción y registrándote con sus enlaces de afiliados.
            Ellos ganan incluso cuando tú pierdes. Estás jugando un juego
            diseñado para que el Tipster Gane con todo lo que tu haces.
          </p>
        </div>

        {/* Failed Approaches */}
        <div className="bg-brand-card border border-brand-red/20 rounded-xl p-8 shadow-xl" data-id="element-109">
          <h3 className="text-2xl text-brand-red mb-6 flex items-center gap-2" data-id="element-110">
            POR QUÉ SIGUES PERDIENDO DINERO (AUNQUE CREAS QUE NO)
          </h3>
          <ul className="space-y-4" data-id="element-111">
            {['Seguir "Stakes 10" emocionales que no tienen ningún respaldo estadístico real.', 'Apostar al Real Madrid o al City solo por el nombre, ignorando que los jugadores vienen de viajes de 10 horas.', 'Usar aplicaciones de resultados en vivo sin entender qué es el xG (Goles Esperados) o la probabilidad implícita.', 'No tener una gestión de Bankroll, lo que te hace apostar el 50% de tu dinero en una sola jugada por desesperación.'].map((item, index) => <li key={index} className="flex items-start gap-3 text-brand-muted" data-id="element-112">
                <XCircleIcon className="w-5 h-5 text-brand-red/70 mt-1 flex-shrink-0" data-id="element-113" />
                <span className="text-lg" data-id="element-114">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}